"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Dropdown = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _async = _interopRequireDefault(require("react-select/async"));
var _react = _interopRequireWildcard(require("react"));
var _reactSelect = _interopRequireWildcard(require("react-select"));
var _core = require("@material-ui/core");
var _icons = require("@material-ui/icons");
var _styles = require("./styles");
var _excluded = ["label", "value", "onChange", "helpertext", "disabled", "options", "id", "name", "data-testid", "error", "isSearchable", "styles", "components", "className", "onBlur", "onFocus"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/**
 * Dropdown component
 * @return {Object}
 */
var Dropdown = function Dropdown(_ref) {
  var label = _ref.label,
    originalValue = _ref.value,
    _ref$onChange = _ref.onChange,
    originalOnChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
    helpertext = _ref.helpertext,
    disabled = _ref.disabled,
    options = _ref.options,
    id = _ref.id,
    name = _ref.name,
    dataTestId = _ref['data-testid'],
    error = _ref.error,
    isSearchable = _ref.isSearchable,
    _ref$styles = _ref.styles,
    originalStyles = _ref$styles === void 0 ? {} : _ref$styles,
    _ref$components = _ref.components,
    originalComponents = _ref$components === void 0 ? {} : _ref$components,
    className = _ref.className,
    _ref$onBlur = _ref.onBlur,
    onBlur = _ref$onBlur === void 0 ? function () {} : _ref$onBlur,
    _ref$onFocus = _ref.onFocus,
    _onFocus = _ref$onFocus === void 0 ? function () {} : _ref$onFocus,
    restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var internalValue = options && options.find(function (_ref2) {
    var value = _ref2.value;
    return value === originalValue;
  }) || null;
  var _useState = (0, _react.useState)(null),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    editing = _useState2[0],
    setEditing = _useState2[1];
  var internalOnChange = function internalOnChange(target, action) {
    var event = {
      target: {
        name: action.name,
        value: target.value
      }
    };
    originalOnChange(event);
    onBlur(event);
  };
  var internalStyles = _objectSpread({
    option: function option(provided) {
      return _objectSpread(_objectSpread({}, provided), {}, {
        padding: 0,
        backgroundColor: 'transparent',
        '&:hover': {
          backgroundColor: 'rgba(0, 0, 0, 0.14)'
        }
      });
    },
    menu: function menu(provided) {
      return _objectSpread(_objectSpread({}, provided), {}, {
        borderTopLeftRadius: '0px',
        borderTopRightRadius: '0px',
        zIndex: 9999,
        marginTop: '4px'
      });
    },
    control: function control(provided, state) {
      var borderBottom = '1px solid #6F878F';
      if (disabled) borderBottom = '0px solid';
      if (error) borderBottom = '2px solid red';else if (state.isFocused) borderBottom = '2px solid #215265';
      return {
        display: 'flex',
        padding: '20px 8px 10px 16px',
        borderRadius: '4px 4px 0 0',
        borderBottom: borderBottom,
        '&:hover': {
          backgroundColor: '#DEE5EA'
        },
        backgroundColor: '#F5F8FA'
      };
    },
    input: function input(provided) {
      return _objectSpread(_objectSpread({}, provided), {}, {
        padding: '0px',
        '& div': {
          fontSize: '1rem'
        },
        '& input': {
          fontWeight: 400,
          fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif'
        }
      });
    },
    placeholder: function placeholder(compProps) {
      return _objectSpread({}, compProps);
    },
    valueContainer: function valueContainer(compProps) {
      return _objectSpread(_objectSpread({}, compProps), {}, {
        padding: '0px',
        height: '25px'
      });
    },
    singleValue: function singleValue(compProps) {
      return _objectSpread(_objectSpread({}, compProps), {}, {
        margin: '0px'
      });
    },
    dropdownIndicator: function dropdownIndicator(defaultStyles, state) {
      return {
        flex: '1',
        color: disabled ? '#9D9D9D' : 'rgba(0, 0, 0, 0.54)',
        transition: 'all .2s ease',
        transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : null,
        '& svg': {
          height: '100%'
        }
      };
    },
    indicatorsContainer: function indicatorsContainer() {
      return {
        cursor: 'pointer',
        height: '25px',
        width: '25px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        '&:hover': {
          backgroundColor: 'lightgrey',
          transition: 'background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
          borderRadius: '50%'
        }
      };
    }
  }, originalStyles);
  var MenuList = function MenuList(compProps) {
    return /*#__PURE__*/_react["default"].createElement(_reactSelect.components.MenuList, (0, _extends2["default"])({}, compProps, {
      innerProps: _objectSpread(_objectSpread({}, compProps.innerProps), {}, {
        role: 'menu-list'
      })
    }), compProps.children);
  };
  var Option = function Option(compProps) {
    return /*#__PURE__*/_react["default"].createElement(_reactSelect.components.Option, (0, _extends2["default"])({}, compProps, {
      innerProps: _objectSpread(_objectSpread({}, compProps.innerProps), {}, {
        role: 'option'
      })
    }), /*#__PURE__*/_react["default"].createElement(_core.ButtonBase, {
      className: className,
      "data-testid": "".concat(dataTestId, "-option-").concat(compProps.value)
    }, compProps.children));
  };
  var DropdownIndicator = function DropdownIndicator(compProps) {
    return /*#__PURE__*/_react["default"].createElement(_reactSelect.components.DropdownIndicator, compProps, /*#__PURE__*/_react["default"].createElement(_icons.ArrowDropDown, null));
  };
  var internalComponents = _objectSpread(_objectSpread({
    MenuList: MenuList,
    Option: Option,
    IndicatorSeparator: function IndicatorSeparator() {
      return null;
    }
  }, originalComponents), {}, {
    DropdownIndicator: DropdownIndicator
  });
  var internalProps = _objectSpread(_objectSpread({}, restProps), {}, {
    value: internalValue,
    id: id,
    name: name,
    isDisabled: disabled,
    onChange: internalOnChange,
    maxMenuHeight: 142,
    styles: internalStyles,
    options: options,
    components: internalComponents
  });
  return /*#__PURE__*/_react["default"].createElement(_styles.Styled, {
    className: "".concat(className, " select"),
    error: !!error,
    disabled: disabled,
    originalvalue: originalValue
  }, /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
    className: "form-group",
    "data-testid": dataTestId
  }, /*#__PURE__*/_react["default"].createElement(_core.InputLabel, {
    shrink: !!originalValue || !!(isSearchable && editing)
  }, label), options ? /*#__PURE__*/_react["default"].createElement(_reactSelect["default"], (0, _extends2["default"])({
    onFocus: function onFocus(e) {
      setEditing(true);
      _onFocus(e);
    },
    onBlur: function onBlur() {
      setEditing(false);
    },
    placeholder: ""
  }, internalProps)) : /*#__PURE__*/_react["default"].createElement(_async["default"], (0, _extends2["default"])({
    onFocus: function onFocus(e) {
      setEditing(true);
      _onFocus(e);
    },
    onBlur: function onBlur() {
      setEditing(false);
    },
    placeholder: "",
    cacheOptions: true,
    defaultOptions: true
  }, internalProps))), /*#__PURE__*/_react["default"].createElement(_core.FormHelperText, {
    className: "helper-text"
  }, helpertext));
};
exports.Dropdown = Dropdown;